// Oct 19 2026: safety net for "debounce is not defined" (seen in ~5% of sessions in Clarity).
// custom.js is the first deferred script in theme.liquid, so this runs before search-form.js / cart.js / facets.js.
// global.js redefines debounce normally; this only matters if global.js fails or loads late.
if (typeof window.debounce !== 'function') {
  window.debounce = function (fn, wait) {
    var t;
    return function () {
      var self = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  };
}

function updateVerifiedBadge() {
    if (!window.jQuery) return;
    $('.stamped-main-widget, .stamped-verified-badge').hide();
    $('<span class="stamped-verified-badge" data-type="buyer" data-verified-label="Verified Buyer"></span>').insertAfter('.author');
  }

  function updateOnNextClick() {
    if (!window.jQuery) return;
    $('.next a').on('click', function() {
      setTimeout(function() {
        updateVerifiedBadge();
      }, 1000);
    });
  }

  function handleResize() {
    if (!window.jQuery) return;
    $(window).resize(function() {
      if (screen.width < 768) {
        $('#checkout_logo').insertAfter('#cart_blocks');
      }
    });
  }

  // Run the code after a delay
  setTimeout(function() {
    updateVerifiedBadge();
    updateOnNextClick();
    handleResize();
  }, 3000);